export default __webpack_public_path__ + "static/media/technicolor.f95d5cd4.png";